module.exports = __webpack_public_path__ + "img/dropper.24ac92d0.svg";